import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { About } from "@/components/site/About";
import { ContactFooter } from "@/components/site/ContactFooter";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
      </main>
      <ContactFooter />
    </div>
  );
}
